// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1oHFj","validationTips":"StatementDescriptor_validationTips__2iMrj"};